export default class CuitFormatter {
    unformat(value) {
        if (value === null || value === undefined) {
            return '';
        }
        return String(value).replace(/\D/g, '').slice(0, 11);
    }

    format(value) {
        const digits = this.unformat(value);
        if (!digits) {
            return '';
        }
        if (digits.length <= 2) {
            return digits;
        }
        if (digits.length <= 10) {
            return `${digits.slice(0, 2)}-${digits.slice(2)}`;
        }
        return `${digits.slice(0, 2)}-${digits.slice(2, 10)}-${digits.slice(10)}`;
    }
}

